.prd-header {
  background-color: #cc0000 !important;
}

.stg-header {
  background-color: #15cf0e !important;
}
